import axios from 'axios'
import modulesDriversLoader from '../services/ModulesDriversLoader'

export default class IndustriesService {
    constructor() {
        modulesDriversLoader.load().then(({ getApiRoutes }) => {
            this.apiRotues = { ...getApiRoutes() }
        })
    }

    async fetchList(params = {}) {
        const response = await axios.get(`${this.apiRotues.API_BASE_URL}/supplier/industry/list`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        )

        return response.data.data || []
    }

    async fetchProducts(params = {}, lng) {
        const formattedIndustries = params.selectedIndustryIds?.join(',') || undefined
        const response = await axios.get(`${this.apiRotues.API_BASE_URL}/supplier/industry/products_list`,
            {
                params: {
                    ...params,
                    industries: formattedIndustries,
                    selectedIndustryIds: undefined,
                    language: lng
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        )

        return response.data?.data || null
    }
}
